import { Link } from "gatsby";
import styled from "styled-components";

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownButton = styled.button`
  background: none;
  border: none;
  color: #414141;

  font-size: 1.2rem;
  cursor: pointer;
  padding: 10px;
  transition:
    color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
  font-family: open-sans;
  font-weight: 500;

  &:hover {
    opacity: 0.8;
    color: #6ed976;
  }
`;

export const DropdownContent = styled.div<{ sizeWidth: number }>`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  min-width: ${(props) => props.sizeWidth}ch;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  z-index: 100;
  overflow: hidden;
  text-align: center;

  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition:
    opacity 0.3s ease-in-out,
    transform 0.3s ease-in-out;
`;

export const DropdownItem = styled(Link)`
  display: block;
  padding: 10px;
  color: black;
  text-decoration: none;
  color: #414141;

  transition:
    color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
  &:hover {
    background-color: #f1f1f1;
    color: #6ed976;
  }
`;

export const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${DropdownContent} {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;
